import { Delete, Edit, ScheduleSend, Send } from '@mui/icons-material';
import { Stack, Tooltip } from '@mui/material';
import { GenContextualMenu } from '@pinnacleautomotive/clarity-components';
import { useTranslation } from 'react-i18next';
import { PersonStatus } from '../../../common/enums/enums';

function Options({ onEdit, onResend, onDelete, user }) {
  const { t } = useTranslation('users');

  const options = [
    {
      name: t('options.delete'),
      onClick: onDelete,
      icon: <Delete />,
    },
  ];

  user.status === PersonStatus.PENDING &&
    options.unshift({
      name: t('options.resend'),
      onClick: onResend,
      icon: <Send />,
    });

  user.status !== PersonStatus.PENDING &&
    options.unshift({
      name: t('options.edit'),
      onClick: onEdit,
      icon: <Edit />,
    });

  return <GenContextualMenu options={options} size="small" />;
}

export function OptionsCell({ user, onEdit, onResend, onDelete }) {
  const { t } = useTranslation('users');

  return (
    <Stack direction="row" alignItems="center" justifyContent="end" gap={1.75}>
      {user.status === 'PENDING' && (
        <Tooltip arrow title={t('options.resendTooltip')}>
          <ScheduleSend color="warning" />
        </Tooltip>
      )}
      <Options
        onEdit={onEdit}
        user={user}
        onResend={onResend}
        onDelete={onDelete}
      />
    </Stack>
  );
}
